'use strict';

if (typeof document != 'undefined') require('babel-polyfill');

var Classnames = require('classnames');
var jQuery = require('jquery');
var LinkedStateMixin = require('react-addons-linked-state-mixin');
var React = require('react');
var ReactDOM = require('react-dom');
var ReactRouter = require('react-router');
var Reflux = require('reflux');

var Actions = require('../store').Actions;
var Store = require('../store').Store;
var Components = require('../components');
var Forms = require('../forms');
var Global = require('../global');
var Modal = require('../plugins/modal/');
var Moma = require('../plugins/moma/');
var Constants = require('../constants/');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./fulloffice.scss');
}

var ResponsiveMixin = Global.ResponsiveMixin;
var Media = Components.Media;

var Route  = ReactRouter.Route;
var Router = ReactRouter.Router;

var FULLOFFICE_TAB_AREA    = 0;
var FULLOFFICE_TAB_RANGE   = 1;
var FULLOFFICE_TAB_RESULTS = 2;

var FULLOFFICE_RANGES = [ 'VALUE', 'PRO', 'LUXURY' ];

var FullOffice = React.createClass({
    mixins: [
        LinkedStateMixin,
        Reflux.listenTo(Store, 'onStoreChange', function(initial) {
            if (initial.budgetEstimates.length) {
                var b = initial.budgetEstimates[initial.budgetEstimates.length-1];
                this.setState({
                    area: String(b.area),
                    range: b.range,
                    tabIx: FULLOFFICE_TAB_AREA,
                    results: null,
                });
            }
            else if (initial.fields['pf-area'])
            {
                this.setState({
                    area: initial.fields['pf-area'],
                });
            }
    })],
    onStoreChange: function() {},  // can remove?

    getDefaultProps: function() {
        return {
            gallery: Payload.gallery,
        };
    },
    getInitialState: function() {
        return {
            area: null,
            range: 0,
            results: null,
            tabIx: FULLOFFICE_TAB_AREA
        }
    },

    // Enter advances to next tab
    componentDidMount: function() {
        window.addEventListener('keypress', this.keypress);
    },
    componentWillUnmount: function() {
        window.removeEventListener(this.keypress);
    },
    keypress: function(e) {
        if (e.keyCode == 13 && this.state.tabIx < FULLOFFICE_TAB_RESULTS) {
            this.setState({
                tabIx: this.state.tabIx + 1
            });
        }
    },

    componentDidUpdate: function(prevProps, prevState) {
        if (prevState.area != this.state.area)
        {
            this.setState({ results: null });
        }
        var r = FULLOFFICE_TAB_RESULTS;
        if (!this.state.area || !this.state.area.match(/^[\d,]+$/)) {
            return;
        }
        var area = parseInt(this.state.area.replace(',',''));
        if (prevState != r && this.state.tabIx == r && this.state.results == null && this.state.area != null && area >= 2500)
        {
            this.refs.resultsTab.fetch(area);
        }
    },
    render: function() {
        var tabBody;
        if (this.state.tabIx == FULLOFFICE_TAB_AREA)
        {
            tabBody = <AreaBody />
        }
        else if (this.state.tabIx == FULLOFFICE_TAB_RANGE)
        {
            tabBody = <RangeBody range={this.linkState('range')} gallery={this.props.gallery} />
        }
        else
        {
            tabBody = <ResultsBody area={this.linkState('area')} range={this.linkState('range')} results={this.state.results} />
        }

        return (
            <div>
                <Components.Header tab='fulloffice' landing='standard' />
                <div className='fulloffice'>
                    <AreaTab    area       = {this.linkState('area')}
                                tabIx      = {this.linkState('tabIx')} />

                    <RangeTab   range      = {this.linkState('range')}
                                tabIx      = {this.linkState('tabIx')} />

                    <ResultsTab area       = {this.linkState('area')}
                                range      = {this.linkState('range')}
                                results    = {this.linkState('results')}
                                tabIx      = {this.linkState('tabIx')}
                                ref        = 'resultsTab' />

                    {tabBody}
                </div>
                <Components.Footer />
            </div>
        );
    }
});

// ------------------------------------------------------------------------------

var AreaTab = React.createClass({
    componentDidMount: function() {
        this.refs.input.value = this.props.area.value;
    },
    componentDidUpdate: function(prevProps, prevState) {
        if (this.props.tabIx.value == FULLOFFICE_TAB_AREA)
            ReactDOM.findDOMNode(this.refs.input).focus();
        else
            ReactDOM.findDOMNode(this.refs.input).blur();
    },
    selectTab: function() {
        this.props.tabIx.requestChange(FULLOFFICE_TAB_AREA);
    },
    onKeyDown: function(e) {
        // if (e.keyCode == 13) {
        //     this.props.tabIx.requestChange(FULLOFFICE_TAB_RANGE);
        // }
    },
    render: function() {
        var classes = Classnames({
            'fo-tabHead': true,
            'fo-tabHead-selected': this.props.tabIx.value == FULLOFFICE_TAB_AREA,
            'fo-tabHead-unselected': this.props.tabIx.value != FULLOFFICE_TAB_AREA,
        });
        var mask = null;
        if (this.props.tabIx.value != FULLOFFICE_TAB_AREA)
        {
            mask = (<div className='fo-tabHead-unselectedMask'></div>);
        }
        
        var validate = {};
        if (this.props.area.value && this.props.area.value < 2500) {
            validate = {
                classes: Classnames([ 'fo-tabHead-body-message' ]),
                message: 'Enter at least 2,500 sq. ft.'
            };
        }
        if (this.props.area.value && !this.props.area.value.match(/^[\d,]+$/)) {
            validate = {
                classes: Classnames([ 'fo-tabHead-body-message' ]),
                message: 'Enter a whole number'
            };
        }

        return (
            <div className={classes} onClick={this.selectTab} onTouchEnd={this.selectTab}>
                <div className='fo-tabHead-title'>
                    1 / ENTER OFFICE SIZE
                </div>
                <div className='fo-tabHead-body'>
                    {mask}
                    <input type        = "text"
                           valueLink   = {this.props.area}
                           placeholder = "Enter office area here"
                           ref         = 'input'
                           onKeyDown  = {this.onKeyDown} />
                    <span className='fo-units'>sq. ft.</span>
                    <div className={validate.classes}>
                        {validate.message}
                    </div>
                </div>
            </div>
        );
    }
});

var AreaBody = React.createClass({
    render: function() {
        return (
            <div className='fo-tabBody'>
                <Components.FullOfficeBanner />
            </div>
        );
    }
})

// ------------------------------------------------------------------------------

var RangeRadio = React.createClass({
    handleRangeChange: function(e) {
        this.props.range.requestChange(e.target.value);
    },
    componentDidUpdate: function() {
        if (this.props.tabIx.value == FULLOFFICE_TAB_RANGE && this.props.range.value == this.props.ident)
        {
            ReactDOM.findDOMNode(this.refs.radio).focus();
        }
    },
    render: function() {
        return (
            <Forms.Radio ref          = 'radio'
                         label        = {FULLOFFICE_RANGES[this.props.ident]}
                         handleChange = {this.handleRangeChange}
                         ident        = {this.props.ident}
                         checked      = {this.props.range.value == this.props.ident}
                         active       = {this.props.tabIx.value == FULLOFFICE_TAB_RANGE} />
        );
    }
});

var RangeTab = React.createClass({
    keyPress: function(e) {
        if (this.props.tabIx.value == FULLOFFICE_TAB_RANGE && e.keyCode == 13) {
            this.props.tabIx.requestChange(FULLOFFICE_TAB_RESULTS);
        }
    },
    selectTab: function() {
        this.props.tabIx.requestChange(FULLOFFICE_TAB_RANGE);
    },
    render: function() {
        var classes = Classnames({
            'fo-tabHead': true,
            'fo-tabHead-selected': this.props.tabIx.value == FULLOFFICE_TAB_RANGE,
            'fo-tabHead-unselected': this.props.tabIx.value != FULLOFFICE_TAB_RANGE,
        });
        var mask = null;
        if (this.props.tabIx.value != FULLOFFICE_TAB_RANGE)
        {
            mask = (<div className='fo-tabHead-unselectedMask'></div>);
        }
        return (
            <div className={classes} onClick={this.selectTab} onTouchEnd={this.selectTab}>
                <div className='fo-tabHead-title'>
                    2 / CHOOSE CLASS
                </div>
                <div className='fo-tabHead-body'>
                    {mask}
                    <form>
                        <RangeRadio tabIx={this.props.tabIx} range={this.props.range} ident={0} />
                        <RangeRadio tabIx={this.props.tabIx} range={this.props.range} ident={1} />
                        <RangeRadio tabIx={this.props.tabIx} range={this.props.range} ident={2} />
                    </form>
                    <div className='fo-tabHead-body-message'>
                        View Furniture Examples In This Budget Class Below
                    </div>
                </div>
            </div>
        );
    }
});

var RangeBody = React.createClass({
    render: function() {
        const gallerySpec = {
            desktop: {
                position: 'inside',
                graphic: 'solid',
                navigation: 'hero',
            },
        };
        const gallery = this.props.gallery[this.props.range.value];
        return (
            // Date.now() forces reset of child components, i.e. MomaTrack's cache gets cleared
            <div className='fo-tabBody' key={Date.now()} >
                <RangeGallery spec    = {gallerySpec}
                              gallery = {gallery}
                              type    = 'hero' />
            </div>
        );
    }
});

var RangeGallery = React.createClass({
    mixins: [ Moma, ResponsiveMixin ],

    AssetSizes: function() {
        return {
            desktop: {
                width: Constants.Breaks.DesktopWidth,
                height: 418,
            },
        };
    },
    slideContent: function(slide) {
        return (
            <Media media={slide} height={418} className='fo-tabBody-gallery-image' />
        );
    }    
});

// ------------------------------------------------------------------------------

var ResultsTab = React.createClass({
    getInitialState: function() {
        return {
            results: null,
        }
    },
    selectTab: function() {
        this.props.tabIx.requestChange(FULLOFFICE_TAB_RESULTS);
    },
    fetch: function(area) {
        var _this = this;
        jQuery.post('', { 'area': area }, function(data, textStatus, jqXHR) {
            if (_this.isMounted()) {
                _this.props.results.requestChange(data);
            }
        });
    },
    render: function() {
        var classes = Classnames({
            'fo-tabHead': true,
            'fo-tabHead-selected': this.props.tabIx.value == FULLOFFICE_TAB_RESULTS,
            'fo-tabHead-unselected': this.props.tabIx.value != FULLOFFICE_TAB_RESULTS,
        });
        var mask = null;
        if (this.props.tabIx.value != FULLOFFICE_TAB_RESULTS)
        {
            mask = (<div className='fo-tabHead-unselectedMask'></div>);
            var head_body;
            if (!this.props.results.value) {
                head_body = (<Forms.Button label='CALCULATE' type='neutral' inactive={true} />);
            }
            else
            {
                var res = this.props.results.value[this.props.range.value];
                head_body = (<ResultMatrix result={res} inline={true} />);
            }
        }
        else
        {
            if (!this.props.results.value) {
                head_body = (
                    <Forms.Button label    = 'CALCULATE'
                                  type     = 'neutral'
                                  inactive = {!this.props.results.value} />
                );
            }
            else
            {
                head_body = (
                    <div>
                        <p>
                            Enjoy a stress-free purchasing experience, starting with the Budget Your Office tool. Gain an expert
                            preliminary budget estimate. View budgetary examples from our three best-in-show furniture classes.
                            Compare and select your preferred budget class, then submit your form. Our knowledgeable staff will
                            guide you the rest of the way. 
                        </p>
                        <p className='fo-financeLink'>
                            We also have <a href="/office-furniture-leasing">financing available</a>.
                        </p>
                    </div>
                );
            }
        }
        return (
            <div className={classes} onClick={this.selectTab} onTouchEnd={this.selectTab}>  {/* .fo-tabHead */}
                <div className='fo-tabHead-title'>
                    3 / CALCULATE ESTIMATE
                </div>
                <div className='fo-tabHead-body'>
                    {mask}
                    {head_body}
                </div>
            </div>
        );
    }
});

var ResultsBody = React.createClass({
    submit: function(range) {
        // Save to local storage
        Actions.setBudgetEstimate({
            area: parseInt(this.props.area.value.replace(',','')),
            range: range,
            results: this.props.results[range]
        });
        window.location = '/your-project/specs';
    },
    render: function() {
        var sidebar = null;
        if (this.props.results)
        {
            var res0 = this.props.results[0];
            var res1 = this.props.results[1];
            var res2 = this.props.results[2];

            sidebar = (
                <div className='fo-resultsSidebar'>

                    <div className='fo-resultsSidebar-result'>
                        <h1>VALUE</h1>
                        <ResultMatrix result={res0} inline={false} />
                        <div className='fo-resultsSidebar-submit' >
                            <Forms.Button onClick={this.submit.bind(null, 0)} label='SUBMIT' />
                        </div>
                    </div>

                    <div className='fo-resultsSidebar-result'>
                        <h1>PRO</h1>
                        <ResultMatrix result={res1} inline={false} />
                        <div className='fo-resultsSidebar-submit'>
                            <Forms.Button onClick={this.submit.bind(null, 1)} label='SUBMIT' />
                        </div>
                    </div>

                    <div className='fo-resultsSidebar-result'>
                        <h1>LUXURY</h1>
                        <ResultMatrix result={res2} inline={false} />
                        <div className='fo-resultsSidebar-submit'>
                            <Forms.Button onClick={this.submit.bind(null, 2)} label='SUBMIT' />
                        </div>
                    </div>
                    
                </div>
            );
        }
        else
        {
            sidebar = (
                <div className='fo-resultsSidebar-err'>
                    <div>COMPLETE STEPS 1 AND 2</div>
                    <div>TO CALCULATE YOUR PROJECT BUDGET</div>
                </div>
            );
        }

        return (
            <div className='fo-tabBody'>
                <div className='fo-tabBody-results '>
                    <ModalVideo />

                    <div className='fo-tabBody-results-sidebar'>
                        {sidebar}
                    </div>
                </div>
            </div>
        );
    },
});

var ResultMatrix = React.createClass({
    render: function() {
        var classes = Classnames({
            'fo-resultMatrix': true,
            'fo-resultMatrix-inline': this.props.inline,
        });
        return (
            <div className={classes}>
                <div className='fo-resultMatrix-from'>
                    <div className='fo-resultMatrix-label'>
                        FROM&nbsp;
                        <span className='fo-resultMatrix-gross'>
                            (${this.props.result.lowerGross})
                        </span>
                    </div>
                    <div className='fo-resultMatrix-value'>
                        ${this.props.result.lowerMonth}
                        /month
                    </div>
                </div>
                <div className='fo-resultMatrix-to'>
                    <div className='fo-resultMatrix-label'>
                        TO&nbsp;
                        <span className='fo-resultMatrix-gross'>
                            (${this.props.result.upperGross})
                        </span>
                    </div>
                    <div className='fo-resultMatrix-value'>
                        ${this.props.result.upperMonth}
                        /month
                    </div>
                </div>
            </div>
        );
    }
});

var ModalVideo = React.createClass({
    getInitialState: function() {
        return {
            hover: false
        };
    },
    mouseOver: function(e) {
        this.setState({ hover: true });
    },
    mouseLeave: function(e) {
        this.setState({ hover: false });
    },
    open: function() {
        this.refs.modal.open();
    },
    render: function() {
        var playImage = Constants.static + (this.state.hover ? '/images/moma/play-active.png' : '/images/moma/play-inactive.png');
        return (
            <div className='fo-tabBody-results-video'>
                <div onClick={this.open} onMouseOver={this.mouseOver} onMouseLeave={this.mouseLeave}>
                    <div className='fo-tabBody-results-video-cover'>
                        <img src={Constants.static + '/images/fulloffice/cover2.jpg'} />
                        <img className='fo-tabBody-results-playbutton' src={playImage} />
                    </div>
                    <div className='fo-tabBody-results-caption'>
                        See what our clients say about us.
                    </div>
                    <Forms.Button label='WATCH' onClick={this.open} />
                </div>
                <Modal width={726} height={403} ref='modal'>
                    <iframe width                 = "726"
                            height                = "403"
                            src                   = "//player.vimeo.com/video/123676395?badge=0&byline=0&title=0"
                            frameBorder           = "0"
                            allowFullScreen       = ""
                            mozallowfullscreen    = ""
                            webkitallowfullscreen = ""
                            title                 = "Full office"
                            ></iframe>
                </Modal>
            </div>
        );
    }
});

// ------------------------------------------------------------------------------

var routes = (
    <Route component={FullOffice} path='/budget-your-office' />
);

if (isNode) {
    global.routes = routes;
} else {
    var dom = (
        <Router history={Global.History}>
            {routes}
        </Router>
    );
    ReactDOM.render(dom, document.getElementById('fulloffice'));
}



// WEBPACK FOOTER //
// ./src/fulloffice/fulloffice.jsx